import {useIntl} from 'react-intl'
import crossIcon from '../../../../../_metronic/assets/images/svg/data-room/cross-black-icon.svg'
import {useState} from 'react'
import {Formik} from 'formik'
import * as Yup from 'yup'
import {useThemeMode} from '../../../../../_metronic/partials'
import TextInput from '../../../widgets/components/Input/TextInput'
import {BasicButton} from '../../../widgets/components/UI/BasicButton'
import SelectSearchInput from '../../../widgets/components/Input/SelectSearchInput'
import {SelectInput} from '../../../widgets/components/Input/SelectInput'
import TagifyInput from '../../../shared-access/components/tagify-input'
import {convertToBytes} from '../../../../core/_util'

export const DataTableFilterSearchFilter = ({
  filter,
  setFilter,
  setClear,
  setFileNameSearch,
  setSourceNameSearch,
  setSourceTypeSearch,
  setFileTypeSearch,
  setMaxSize,
  setMinSize,
  setUploadedAfter,
  setUploadedBefore,
  setUploadedBy,
  setIsFilterApplied,
}: any) => {
  const {formatMessage} = useIntl()
  const {mode} = useThemeMode()
  const [filterLoading, setFilterLoading] = useState(false)
  const initialValues = {
    fileNameSearch: '',
    sourceNameSearch: '',
    sourceTypeSearch: '',
    fileTypeSearch: '',
    maxSize: null,
    minSize: null,
    uploadedAfter: '',
    uploadedBefore: '',
    uploadedBy: null,
    maxSizeType: '',
    minSizeType: '',
  }
  const searchSchema = Yup.object().shape({
    fileNameSearch: Yup.string().nullable(),
    sourceNameSearch: Yup.string().nullable(),
    sourceTypeSearch: Yup.string().nullable(),
    fileTypeSearch: Yup.string().nullable(),
    maxSize: Yup.number().nullable(),
    minSize: Yup.number().nullable(),
    uploadedAfter: Yup.string().nullable(),
    uploadedBefore: Yup.string().nullable(),
    uploadedBy: Yup.number().nullable(),
    maxSizeType: Yup.string().nullable(),
    minSizeType: Yup.string().nullable(),
  })
  const closeFilter = () => {
    setFilter(false)
  }

  const clearFilters = (formik: any) => {
    setIsFilterApplied(false)
    formik.resetForm({values: formik.initialValues})
    setClear(true)
    setFilter(false)
    setFileNameSearch('')
    setSourceNameSearch('')
    setSourceTypeSearch('')
    setFileTypeSearch('')
    setMaxSize('')
    setMinSize('')
    setUploadedAfter('')
    setUploadedBefore('')
    setUploadedBy('')
  }

  const onApplyFilter = async (values: any) => {
    setIsFilterApplied(true)
    setFileNameSearch(values.fileNameSearch)
    setSourceNameSearch(values.sourceNameSearch)
    setSourceTypeSearch(values.sourceTypeSearch)
    setFileTypeSearch(values.fileTypeSearch)
    if (values.maxSize && values.maxSizeType) {
      setMaxSize(convertToBytes(values.maxSize, values.maxSizeType))
    }

    if (values.minSize && values.minSizeType) {
      setMinSize(convertToBytes(values.minSize, values.minSizeType))
    }
    setUploadedAfter(values.uploadedAfter)
    setUploadedBefore(values.uploadedBefore)
    setUploadedBy(values.uploadedBy)
    setFilterLoading(true)
    setFilterLoading(false)
    setFilter(false)
    setClear(false)
  }

  return (
    <div
      className={filter ? 'bg-body drawer drawer-end drawer-on' : 'bg-body drawer drawer-end'}
      id='fc-filter'
      data-kt-drawer='true'
      data-kt-drawer-name='filter'
      data-kt-drawer-overlay='true'
      data-kt-drawer-activate='true'
      data-kt-drawer-width="{default:'300px', 'md': '400px'}"
      data-kt-drawer-direction='end'
    >
      {/* Card */}
      <div className='card shadow-none rounded-0 w-100'>
        {/* Header */}
        <div className='card-header' id='fc_header'>
          <div className='card-toolbar gap-6'>
            <button
              type='button'
              className='btn btn-sm btn-icon explore-btn-dismiss me-n5'
              onClick={closeFilter}
            >
              <img src={crossIcon} alt='Close' />
            </button>
            <h5 className='card-title fw-bold'>{formatMessage({id: 'Sort or Filter'})}</h5>
          </div>
        </div>
        {/* Body */}
        <Formik
          initialValues={initialValues}
          validationSchema={searchSchema}
          onSubmit={onApplyFilter}
          validateOnMount
          enableReinitialize
        >
          {(formik: any) => {
            console.log(formik.values, '  formik')
            return (
              <>
                <div className='card-body'>
                  {/* Clear All Filters */}
                  <div className='mb-5'>
                    <BasicButton
                      id='fc-clear'
                      height='36px'
                      border='none'
                      color={mode === 'dark' ? '#323248' : '#F5F8FA'}
                      textColor={mode === 'dark' ? '#FFFFFF' : '#585960'}
                      padding='8px 16px'
                      buttonText={formatMessage({id: 'Clear All filters'})}
                      minWidth={125}
                      onClick={() => clearFilters(formik)}
                    />
                  </div>
                  <TextInput
                    fieldType='text'
                    fieldName='fileNameSearch'
                    formik={formik}
                    label={formatMessage({id: 'File Name'})}
                    placeholder={formatMessage({id: 'Search Files Name'})}
                    isWidthNotRequired={true}
                    isTooltipNotRequired={true}
                  />
                  <TextInput
                    fieldType='text'
                    fieldName='sourceNameSearch'
                    formik={formik}
                    label={formatMessage({id: 'Source Name'})}
                    placeholder={formatMessage({id: 'Search Source Name'})}
                    isWidthNotRequired={true}
                    isTooltipNotRequired={true}
                  />
                  <SelectSearchInput
                    label={formatMessage({id: 'Source Types'})}
                    fieldName='sourceTypeSearch'
                    placeholder={formatMessage({
                      id: 'Please select the Range Between File Size',
                    })}
                    formik={formik}
                    options={[]}
                    isStarRequired={false}
                    isTooltipNotRequired={true}
                  />
                  <div className='mb-8'>
                    <TagifyInput
                      label={formatMessage({id: 'File Type'})}
                      placeholder={formatMessage({id: 'Search File Type'})}
                      isTooltipRequired={false}
                      fieldName='fileTypeSearch'
                      formik={formik}
                    />
                  </div>
                  <div>
                    <label>{formatMessage({id: 'File Size Bigger Than'})}</label>
                    <div className='d-flex align-items-center'>
                      <div className='col-md-8 col-8 pe-2'>
                        <TextInput
                          fieldType='number'
                          fieldName='minSize'
                          formik={formik}
                          placeholder={'Enter Size'}
                          isTooltipNotRequired
                        />
                      </div>

                      <div className='col-md-4 col-4 mb-1'>
                        <SelectInput
                          fieldName='minSizeType'
                          placeholder='Select'
                          formik={formik}
                          options={['KB', 'MB', 'GB']}
                          isTooltipNotRequired
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <label>{formatMessage({id: 'File Size Smaller Than'})}</label>
                    <div className='d-flex align-items-center'>
                      <div className='col-md-8 col-8 pe-2'>
                        <TextInput
                          fieldType='number'
                          fieldName='maxSize'
                          formik={formik}
                          placeholder={'Enter Size'}
                          isTooltipNotRequired
                        />
                      </div>

                      <div className='col-md-4 col-4 mb-1'>
                        <SelectInput
                          fieldName='maxSizeType'
                          placeholder='Select'
                          formik={formik}
                          options={['KB', 'MB', 'GB']}
                          isTooltipNotRequired
                        />
                      </div>
                    </div>
                  </div>
                  <TextInput
                    fieldType='date'
                    fieldName='uploadedBefore'
                    formik={formik}
                    label={formatMessage({id: 'Uploaded Before'})}
                    placeholder={formatMessage({id: 'Enter Uploaded Before Date'})}
                    isWidthNotRequired={true}
                    isTooltipNotRequired={true}
                  />
                  <TextInput
                    fieldType='date'
                    fieldName='uploadedAfter'
                    formik={formik}
                    label={formatMessage({id: 'Uploaded After'})}
                    placeholder={formatMessage({id: 'Enter Uploaded After Date'})}
                    isWidthNotRequired={true}
                    isTooltipNotRequired={true}
                  />
                  <div className='mb-8'>
                    <TagifyInput
                      label={formatMessage({id: 'Uploaded By'})}
                      placeholder={formatMessage({id: 'Please Select the User'})}
                      isTooltipRequired={false}
                      fieldName='uploadedBy'
                      formik={formik}
                    />
                  </div>
                </div>
                {/* Footer */}
                <div
                  className='d-flex justify-content-center m-md-5 m-0 w-100 w-md-auto px-4'
                  id='fc_footer'
                >
                  <BasicButton
                    id='fc-apply'
                    border='#4776E6'
                    color='#4776E6'
                    textColor='#FFFFFF'
                    // padding="16px 138px"
                    buttonText={formatMessage({id: 'Apply filters'})}
                    minWidth={352}
                    loading={filterLoading}
                    disabled={filterLoading || !formik.isValid}
                    onClick={() => onApplyFilter(formik.values)}
                    customClass='w-100 mb-4 custom-button-property'
                  />
                </div>
              </>
            )
          }}
        </Formik>
      </div>
    </div>
  )
}
